module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Mary-Shelley.60c336d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Mary-Shelley.jpg
// module id = fSu7
// module chunks = 0